import { z } from 'zod';
import { issueCommentSchema } from './IIssueShared';

export const issueCommentCreatedNotificationMetadataSchema = z.object({
	userDetails: z.object({
		name: z.string(),
	}),
	issueDetails: z.object({
		description: z.string(),
		issueId: z.string(),
	}),
	comment: issueCommentSchema,
});

export type IIssueCommentCreatedNotificationMetadata = z.infer<typeof issueCommentCreatedNotificationMetadataSchema>;
